import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseEventMessage } from 'entities/Message'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventMessageUpdatedNewGlobal = (
  handler: (response: IResponseEventMessage) => void,
  deps: unknown[] = []
) => {
  const entities = useEntitiesContext()
  const _handler = (response: IResponseEventMessage) => {
    const normalizeResponse: IResponseEventMessage = {
      ...response,
      conversation: {
        ...response.conversation,
        contact: response.contact || response.conversation.contact,
      },
    }
    handler(normalizeResponse)
  }

  useEffect(() => entities.websocket.on(WebsocketEvent.MessageUpdatedNew, _handler), deps)
}
